export default __webpack_public_path__ + "static/media/iot.0f267911.webp";